// Quand Radar fait monter un score (chantier « Mouvement », #183).
//
// Décision de Nicolas du 2026-10-15 : le score monte la première fois qu'on
// voit une offre, jamais ensuite ; une liste (accueil, Mes offres) joue une
// fois par session. La mémoire est celle du navigateur : un autre appareil
// rejoue une fois, c'est voulu (ce n'est pas une donnée, c'est un affichage).
//
// À appeler dans un initialiseur de useState, jamais pendant le rendu : en
// mode strict, React l'appelle deux fois et garde le premier résultat.

import { memoireDesVus, stockageNavigateur } from '@ai-job-fit/ui'

export function premiereVueDuScore(offreId: number | string): boolean {
  return memoireDesVus(stockageNavigateur('local'), 'radar.scoresVus').premiereFois(String(offreId))
}

export function premiereFoisCetteSession(liste: 'accueil' | 'mesoffres'): boolean {
  return memoireDesVus(stockageNavigateur('session'), 'radar.listesJouees').premiereFois(liste)
}

/** « Ce que l'offre demande » se coche une fois par offre (#187), mémoire à part de celle du score. */
export function premiereVueDesExigences(offreId: number | string): boolean {
  return memoireDesVus(stockageNavigateur('local'), 'radar.exigencesVues').premiereFois(String(offreId))
}
